import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TextFieldData from "./TextFiledData"; // Fixed import name
import { Box, Button } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../Layout/GRISidebar";
import { put, api, get } from "../../../utils/api";
import ReviewBox from "../../../Components/Common/ReviewBox";
import { currentYear } from "../../../utils/generateYearRanges";

const Economic213 = ({ hide }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [errors, setErrors] = useState({});
  const [disabled, setDisabled] = useState(false);
  const [fromData, setFromData] = useState({
    governanceBodyDelegationOfResponsibility: {
      seniorExecutivesDeveloping: "",
      seniorExecutiveResponsibilityRole: "",
      responsibilityDelegatedToEmployees: "",
    },
    reportingToGovernanceBodyFrequency: "",
  });
  const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));

  // Function to validate the form fields
  const validateFields = () => {
    const newErrors = {};

    // Loop through the 'fromData' object and validate
    Object.keys(fromData).forEach((sectionKey) => {
      const section = fromData[sectionKey];

      // If section is an object, loop through the fields inside it
      if (typeof section === "object") {
        Object.keys(section).forEach((fieldKey) => {
          if (!section[fieldKey]) {
            // If the field is empty, mark it as an error
            if (!newErrors[sectionKey]) {
              newErrors[sectionKey] = {};
            }
            newErrors[`${sectionKey}.${fieldKey}`] = `This field is required`;
          }
        });
      } else if (!section) {
        // If section is not an object, just check the value
        newErrors[sectionKey] = `This field is required`;
      }
    });
    console.log(newErrors);
    setErrors(newErrors);
    return newErrors;
  };

  // Function to handle form submission
  const handleSubmit = async () => {
    // const validationErrors = validateFields();

    // If there are errors, prevent form submission
    // if (Object.keys(validationErrors).length > 0) {
    //   console.log("Form contains errors", fromData, validationErrors);
    //   return;
    // }
    if (!disabled) {
      try {
        const token = sessionStorage.getItem("token");
        if (!token) {
          throw new Error("Authentication token is missing.");
        }
        await put(`/gri/update?Id=${id}`, {
          type: "GeneralDisclosures2021",
          delegation: { ...fromData },
          submitted2_13: true,
        })
          .then((res) => navigate(`/gri/general-disclosure/2-14/${id}`))
          .catch((err) => console.log(err));
      } catch {
        console.log(errors);
      }
    } else {
      navigate(`/gri/general-disclosure/2-14/${id}`);
    }
  };

  const fetchData = async () => {
    await get(`/gri/get?type=GeneralDisclosures2021&Id=${id}`)
      .then((res) => {
        if (res?.data?.data?.year ? res?.data?.data?.year < currentYear -1 : false)
          setDisabled(true);
        setFromData({
          governanceBodyDelegationOfResponsibility: {
            seniorExecutivesDeveloping:
              res.data.data.GeneralDisclosures2021.delegation
                .governanceBodyDelegationOfResponsibility
                .seniorExecutivesDeveloping,
            seniorExecutiveResponsibilityRole:
              res.data.data.GeneralDisclosures2021.delegation
                .governanceBodyDelegationOfResponsibility
                .seniorExecutiveResponsibilityRole,
            responsibilityDelegatedToEmployees:
              res.data.data.GeneralDisclosures2021.delegation
                .governanceBodyDelegationOfResponsibility
                .responsibilityDelegatedToEmployees,
          },
          reportingToGovernanceBodyFrequency:
            res.data.data.GeneralDisclosures2021.delegation
              .reportingToGovernanceBodyFrequency,
        });
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    fetchData();
  }, []);

  const inputData = [
    {
      index: "a.",
      heading:
        "Describe how the highest governance body delegates responsibility for managing the organization’s impacts on the economy, environment, and people.",
      subfieldName: "governanceBodyDelegationOfResponsibility",
      fieldName: "seniorExecutivesDeveloping",
      fields: [
        {
          index: "i.",
          subheading:
            "Describe if the highest governance body has appointed any senior executives with specific responsibility for managing the organization's impacts on the economy, environment, and people e.g., Chief Sustainability Officer, ESG Committee Chair.",
          fieldName: "seniorExecutiveResponsibilityRole",
        },
        {
          index: "ii.",
          subheading:
            "Describe if the highest governance body has delegated responsibility for managing these sustainability impacts to other employees beyond the senior executive level and at what level of the organization is this responsibility delegated (e.g., departmental, operational).",
          fieldName: "responsibilityDelegatedToEmployees",
        },
      ],
    },
    {
      index: "b.",
      heading:
        "Describe the process and frequency for senior executives or other employees to report back to the highest governance body on the management of the organization’s impacts on the economy, environment, and people.",
      fieldName: "reportingToGovernanceBodyFrequency",
    },
  ];

  const renderContent = ({ hide }) => (
    <>
      <TextFieldData
        title="2-13 Delegation of responsibility for managing impacts"
        {...{
          inputData,
          fromData,
          setFromData,
          setErrors,
          disabled: disabled,
          errors,
          hide,
        }}
      />
    </>
  );
  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                  onClick={handleSubmit}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default Economic213;
